import React, { FC } from "react";
import classNames from "classnames/bind";
import { Spin, Space } from "antd";
import styles from "./loading.module.css";

const cx = classNames.bind(styles);

interface index {
  overContent?: boolean;
}

export const Loading: FC<index> = ({ overContent }) => {
  return (
    <div className={cx("spinnerWrapper", { overContent: overContent })} data-testid="index">
      <Space size="large">
        <Spin size="large" />
      </Space>
    </div>
  );
};
